(function () {
  const initDropdown = () => {
    const dropdowns = document.querySelectorAll(".dropdown-opener");
    if (!dropdowns.length) return;

    const closeAllDropdownsExcept = (exception = null) => {
      dropdowns.forEach((dropdown) => {
        if (dropdown !== exception) {
          dropdown.classList.remove("active");
        }
      });
    };

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("click", (e) => {
        e.stopPropagation();
        closeAllDropdownsExcept(dropdown);
        dropdown.classList.toggle("active");

        const next = dropdown.nextElementSibling;
        trapFocus(next);
      });

      dropdown.addEventListener("keydown", (e) => {
        const next = dropdown.nextElementSibling;
        const el = next.querySelector("li a");

        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          closeAllDropdownsExcept(dropdown);
          dropdown.classList.toggle("active");
          trapFocus(next, el);
        }
      });
    });

    document.addEventListener("click", (event) => {
      if (
        !event.target.closest(".dropdown-opener") &&
        !event.target.closest(".share-buttons__list") &&
        !event.target.closest(".copy")
      ) {
        closeAllDropdownsExcept();
      } else if (event.target.closest(".copy")) {
        setTimeout(() => {
          closeAllDropdownsExcept();
        }, 800);
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeAllDropdownsExcept();
      }
    });
  };

  const revealStickyBar = (section) => {
    if (!section || !section.classList.contains("product-section")) return;
    const buyButtons = section.querySelector(
      ".product__buy-buttons > product-form"
    );
    const stickyBar = document.querySelector(".product-sticky-bar");
    const footerBottom = document.querySelector(
      ".shopify-section-group-footer-group .footer-bottom"
    );

    if (!stickyBar) return;

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.01,
    };

    const isElementBelowScroll = (element) => {
      return element ? element.getBoundingClientRect().top > 0 : false;
    };

    const toggleStickyBar = (isVisible) => {
      if (isVisible || isElementBelowScroll(buyButtons)) {
        stickyBar.classList.remove("active");
      } else {
        stickyBar.classList.add("active");
      }
    };

    const handleIntersect = (entries) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      toggleStickyBar(isVisible);
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (buyButtons) observer.observe(buyButtons);
    if (footerBottom) observer.observe(footerBottom);
  };

  const initProductAccordion = () => {
    const toggles = document.querySelectorAll(".about__accordion-toggle");

    toggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const descriptions = toggle.parentElement.querySelectorAll(
          ".about__accordion-description"
        );

        if (!toggle.classList.contains("active")) {
          toggle.classList.add("active");

          const index = Array.from(toggle.parentElement.children).indexOf(
            toggle
          );
          const target = descriptions[index];

          if (target) {
            slideDown(toggle, target);
          }
        } else {
          toggle.classList.remove("active");

          descriptions.forEach((desc) => {
            slideUp(toggle, desc);
          });
        }
      });
    });
  };

  initDropdown();
  revealStickyBar(document.currentScript.parentElement);
  initProductAccordion();

  document.addEventListener("shopify:section:load", (event) => {
    revealStickyBar(event.target);
    if (!window.Shopify.designMode) {
      initDropdown();
      initProductAccordion();
    }
  });
})();
